import React, { useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import ToolStatePanel from "../../__shared/ToolStatePanel";
import "./TeamScheduleDisplay.css";

const GET_TEAM_SCHEDULE = graphql`
  query TeamScheduleDisplayQuery($teamId: ID!, $seasonID: ID) {
    nflGameResultsForTeam(teamId: $teamId, seasonId: $seasonID) {
      week {
        week
      }

      team {
        city
        logoSrc
      }

      opp {
        city
        logoSrc
      }

      teamScore
      oppScore

      home
    }
  }
`;

function resultClass(score, other) {
  if (score === other) {
    return "nfl-sr-score";
  }
  return score > other ? "nfl-sr-score is-win" : "nfl-sr-score is-loss";
}

export default function TeamScheduleDisplay({ teamId, seasonID, fetchKey }) {
  const [open, setOpen] = useState(true);

  const data = useLazyLoadQuery(
    GET_TEAM_SCHEDULE,
    { teamId, seasonID },
    { fetchKey, fetchPolicy: fetchKey > 0 ? "network-only" : "store-or-network" }
  );

  if (!data.nflGameResultsForTeam) {
    throw new Error("nflGameResultsForTeam returned null");
  }

  const results = data.nflGameResultsForTeam;

  return (
    <section className="nfl-sr-schedule">
      <div className="nfl-sr-schedule-head">
        <h2 className="nfl-sr-schedule-title nfl-display">Schedule</h2>
        <button
          type="button"
          className="nfl-link-button"
          aria-expanded={open}
          onClick={() => setOpen((isOpen) => !isOpen)}
        >
          {open ? "Hide" : "Show"}
        </button>
      </div>

      {open && results.length === 0 ? (
        <ToolStatePanel title="No games yet" body="Results show up after week 1." />
      ) : null}

      {open && results.length > 0 ? (
        <table className="nfl-sr-schedule-table">
          <thead>
            <tr>
              <th scope="col">Wk</th>
              <th scope="col">Tm</th>
              <th scope="col">
                <span className="nfl-sr-visually-hidden">Team score</span>
              </th>
              <th scope="col">Opp</th>
              <th scope="col">
                <span className="nfl-sr-visually-hidden">Opponent score</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {results.map((result) => (
              <tr key={result.week.week}>
                <td>{result.week.week}</td>
                <td>
                  <img
                    className="nfl-sr-schedule-logo"
                    src={result.team.logoSrc}
                    alt={result.team.city}
                  />
                </td>
                <td className={resultClass(result.teamScore, result.oppScore)}>
                  {result.teamScore}
                </td>
                <td>
                  <img
                    className="nfl-sr-schedule-logo"
                    src={result.opp.logoSrc}
                    alt={result.opp.city}
                  />
                </td>
                <td className={resultClass(result.oppScore, result.teamScore)}>
                  {result.oppScore}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </section>
  );
}
